import {useMsal} from '@azure/msal-react';
import type * as React from 'react';
import {Route, Routes, useNavigate} from 'react-router-dom';
import {CustomNavigationClient} from './components/MSAL/NavigationClient';
import HomePage from './pages/HomePage';
import BlankPage from '@/pages/BlankPage';
import MyCapacity from '@/pages/MyCapacity';

const App = () : React.ReactElement => {
    const {instance} = useMsal();
    const navigate = useNavigate();
    const navigationClient = new CustomNavigationClient(navigate);
    instance.setNavigationClient(navigationClient);

    return <Routes>
        <Route path="/" element={<HomePage/>}/>
        <Route path="/my-capacity" element={<MyCapacity/>}/>
        <Route path="/blank" element={<BlankPage/>}/>
    </Routes>;
};

export default App;
